import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import general from "../../general";
import $ from "jquery";
import { useLockFn, useScroll, useUpdateEffect } from "ahooks";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import { CSSTransition } from "react-transition-group";

export default (props) => {
  const [loaded, setLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [datas, setDatas] = useState([]);
  const [more, setMore] = useState(true);

  const load = useLockFn(async (parms = {}) => {
    Dialog.loading();
    let tmp = {
      pagination: { page: page, count: 20 },
    };
    if (parms.page) {
      tmp.pagination.page = parms.page;
    }

    await general.axios
      .post("/v3/recyclableAltGames", tmp)
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let {
          status,
          data: { list, paginated },
        } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setLoaded(true);
          if (parms.page) {
            setPage(parms.page);
          }
          setDatas((datas) =>
            parms.page === 1 || !parms.page ? list : [...datas, ...list],
          );
          setMore(paginated.more && list.length > 0);
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  });

  useEffect(() => {
    if (props.active) {
      load({ page: 1 });
    }
  }, [props.active]);

  const scroll = useScroll();
  useUpdateEffect(() => {
    if (props.active) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 > $(document).height() &&
        more
      ) {
        load({ page: page + 1 });
      }
    }
  }, [scroll, props.active]);

  const [confirm, setConfirm] = useState(true);
  useEffect(() => {
    if (confirm) {
      // iOS Safari 添加到主屏幕后，需要同时设置 html 和 body 才能生效
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      // position: fixed 在 iOS 上防止滚动更可靠
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    }
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    };
  }, [confirm, props.active]);

  return (
    <>
      <div className="recovery-index">
        <div className="recovery-step">
          <div className="step-item">
            <img src="/resources/four-three/trade/icon01.png" alt="" />
            <span className="step-text">选择小号</span>
          </div>

          <div className="step-circle">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>

          <div className="step-item">
            <img src="/resources/four-three/trade/icon02.png" alt="" />
            <span className="step-text">确认提交</span>
          </div>

          <div className="step-circle">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>

          <div className="step-item">
            <img src="/resources/four-three/trade/icon03.png" alt="" />
            <span className="step-text">实时到账</span>
          </div>
        </div>

        <div className="recovery-title">
          可回收的小号
          <Link to="/recovery/record" className="recovery-record-entro">
            回收记录
          </Link>
        </div>

        {datas.length > 0 && (
          <div className="recovery-items">
            {datas.map((item) => (
              <Link
                key={item.id}
                to={"/recovery/select?id=" + item.id}
                className="item"
                onClick={() => {
                  general.game = { img: item.img };
                }}
              >
                <div className="item-game-info">
                  <Image src={item.img.thumb} alt="" />
                  <div>
                    <div className="item-game-name">
                      {item.name_main || item.name}

                      {item.name_branch ? (
                        <div className="item-game-name-branch">
                          {item.name_branch}
                        </div>
                      ) : null}
                    </div>

                    <div className="desc">
                      可回收小号：<span>{item.recyclable}</span>个
                    </div>

                    <div className="desc" style={{ marginTop: "6px" }}>
                      累计充值：<span>{item.rechargedAmount}</span>元
                    </div>
                  </div>
                </div>

                <div className="item-game-price">
                  <div className="item-game-price-text">
                    回收可得：<span>{item.recyclableCoin}福利币</span>
                  </div>

                  <div className="item-game-price-button">去回收</div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {datas.length === 0 && loaded ? (
          <div className="recovery-empty">
            <img src="/resources/recovery/empty.png" alt="" />
            暂无可回收小号
          </div>
        ) : null}
      </div>

      <CSSTransition
        in={confirm}
        timeout={250}
        appear={true}
        unmountOnExit={true}
      >
        <div className="trade-confirm">
          <div className="container">
            <div className="head" style={{ paddingBottom: "17px" }}>
              <div className="title">回收须知</div>

              <img
                style={{ width: "20px", height: "20px" }}
                src="/resources/four-three/trade/close.png"
                alt=""
                onClick={() => {
                  setConfirm(false);
                }}
              />
            </div>
            <div className="main">
              <div className="body">
                <div className="content">
                  <p>
                    累计实际充值（微信/支付宝/平台币）满100元以上小号，可按照实际充值（微信/支付宝/平台币）5%金额回收福利币，充值仅计算2019.09之后小号充值部分，福利币/代金券充值不计算在内。（关服超过三个月及游戏下架超过六个月的小号不支持回收）。
                  </p>
                  <p>
                    购买的小号进行回收仅计算购买后实际充值金额，回收后24小时内可赎回，逾期不可赎回。
                  </p>
                  <p>
                    赎回小号仅支持现金赎回，需额外支付该小号实际充值金额的3%作为赎回手续费。（例：若小号实际充值满100元，回收后可获得50福利币。若用户需要赎回，则需支付5+3=8元）。
                  </p>
                  <p>
                    小号回收成功后，该小号在本游戏中所有区服的角色会一同售出。
                  </p>
                  <p>如有任何疑问，可联系客服咨询！</p>
                </div>

                <div className="title">温馨提示</div>
                <div className="content">
                  <p style={{ color: "#FF3C3C" }}>
                    仅支持现金赎回，回收后，请手动退出游戏，切勿再往这个角色充值，造成损失概不负责！
                  </p>
                  <p>赎回后，可直接选择相应小号登录游戏！</p>
                </div>
              </div>
            </div>
            <div className="operate">
              <div className={"buy"} onClick={() => setConfirm(false)}>
                我知道了
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  );
};
